module.exports = __webpack_public_path__ + "images/花筑pr长图_06-4.jpg?v=5506be5d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_06-4.jpg
 ** module id = 24
 ** module chunks = 1 2
 **/